export default "__VITE_ASSET__da22cb5b__"